import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import FieldMappings from "../components/invoice/FieldMappings";
import SyncRules from "../components/invoice/SyncRules";

import { onChangeInvoiceActiveTab } from "../store/slice/preferenceSlice";
import { clearDefaultValues } from "../store/slice/mappingSlice";

function InvoiceWindow() {
  const invoiceTabKeys = Object.freeze({
    SyncRules: "syncRules",
    FieldMappings: "fieldMappings",
  });
  const dispatch = useDispatch();
  // preference states
  const { invoiceActiveTab } = useSelector((state) => state.preference);
  // invoice states
  const { isInvoiceSyncRulesSaved } = useSelector((state) => state.invoice);
  // mapping states
  const {
    isMappingsSaved: { invoice: isInvoiceMappingsSaved },
    stripe: { loading: stripeLoading },
    msbc: { loading: msbcLoading },
  } = useSelector((state) => state.mapping);

  return (
    <div>
      <Tabs
        defaultActiveKey={invoiceTabKeys.SyncRules}
        onSelect={(selectedKey) => {
          dispatch(clearDefaultValues());
          dispatch(
            onChangeInvoiceActiveTab({
              selectedTab: selectedKey,
              isInvoiceMappingsSaved,
              isInvoiceSyncRulesSaved,
              stripeLoading,
              msbcLoading,
            })
          );
        }}
        activeKey={invoiceActiveTab}
        className="sub-sync-tabs"
        style={{ top: `${window.location.pathname !== "/setup" && "45px"}` }}
      >
        <Tab eventKey={invoiceTabKeys.SyncRules} title="Invoice sync rules">
          <SyncRules />
        </Tab>
        <Tab
          eventKey={invoiceTabKeys.FieldMappings}
          title="Invoice field mappings"
        >
          <FieldMappings />
        </Tab>
      </Tabs>
    </div>
  );
}

export default InvoiceWindow;
